import getPages from "api/requests/wordpress/getPages";
import { Page, RegionRestriction } from "custom-types/Wordpress";
import { createGetServerSideProps } from "utils/createGetServerSideProps";
import {
  redirectToPreviewPage,
  regionRestrictionRedirect,
} from "utils/news/redirect";
import { getCountryCodeHeader } from "utils/requestContext";

import ArticleContent from "@/components/news/ArticleContent";
import PageLayout from "@/components/news/Layouts/PageLayout";

const INFO_PAGE_ID = 61354;

type InfoPageProps = {
  page: Page;
};

const InfoPage: React.FC<InfoPageProps> = ({ page }) => (
  <PageLayout page={page}>
    <ArticleContent item={page} />
  </PageLayout>
);

export const getServerSideProps = createGetServerSideProps<
  InfoPageProps,
  {
    slugs: string[];
  }
>(async (context) => {
  const {
    params: { slugs } = {
      slugs: [""],
    },
    query: { preview_id, preview, page_id },
    resolvedUrl,
  } = context;

  const isPreview =
    (preview_id || page_id) && (preview === "true" || preview === "1");
  if (isPreview) {
    return redirectToPreviewPage((preview_id || page_id) as string, "page");
  }

  const countryCode = getCountryCodeHeader(context.req.headers);

  const { pages } = await getPages(
    countryCode,
    { slug: `${slugs[slugs.length - 1]}` },
    "1",
    "3",
  );

  let page;
  if (pages?.length > 1) {
    page = pages.find((p) => p.topLevelParent === INFO_PAGE_ID);
  } else if (pages?.length === 1) {
    page = pages?.[0];
  }

  if (!page) {
    return {
      notFound: true,
    };
  }

  const { regionRestriction, regionRestrictionRedirectUrl } = page;
  if (
    regionRestrictionRedirectUrl ||
    (regionRestriction !== RegionRestriction.WW &&
      regionRestriction !== countryCode)
  ) {
    return regionRestrictionRedirect(
      resolvedUrl,
      regionRestriction,
      regionRestrictionRedirectUrl,
    );
  }

  return {
    props: {
      page,
    },
  };
});

export default InfoPage;
